import { Card, Col, Row } from 'react-bootstrap';
import Meta from '../Components/Meta';

const VerifyEmployeeScreen = () => {
  return (
    <>
      <Meta title="Employee Verification | KCC Auto Parts" />

      <section className="verify-hero mb-5">
        <Row className="g-4 align-items-center">
          <Col lg={7}>
            <p className="text-uppercase  verify-eyebrow">
              KCC Parts Distribution – Official Employee Verification
            </p>
            <h1 className="mb-3">Know the representative. Protect your shop.</h1>
            <p className="lead mb-4">
              To ensure the security of our clients and the integrity of our
              brand, KCC Parts Distribution provides all authorized representatives with
              a secure Photo ID. Use this page to confirm you are speaking with
              an official member of our team.
            </p>
            <div className="verify-trust">
              <div>
                <span className="verify-trust-title">Secure credentials</span>
                <span className="verify-trust-text">
                  Issued with a photo, Employee ID, and tamper-resistant finish.
                </span>
              </div>
              <div>
                <span className="verify-trust-title">Fast confirmation</span>
                <span className="verify-trust-text">
                  Phone verification from our Ottawa office in minutes.
                </span>
              </div>
            </div>
          </Col>
          <Col lg={5}>
            <Card className="verify-hero-card border-0 shadow-sm">
              <Card.Body>
                <h5 className="mb-2">Need immediate confirmation?</h5>
                <p className="mb-3 text-muted">
                  Call our Ottawa office and provide the Employee ID number
                  shown on the card.
                </p>
                <a className="verify-phone" href="tel:+16134074708">
                  +1 613 407 4708
                </a>
                <p className="mb-0 small text-muted">Mon–Fri, 8:30am–5:00pm ET</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </section>

      <section className="verify-checklist mb-5">
        <Row className="g-4">
          <Col lg={8}>
            <Card className="border-0 shadow-sm verify-card">
              <Card.Body>
                <h2 className="h4 mb-3">How to verify a KCC Parts Distribution ID</h2>
                <ul className="verify-steps">
                  <li>
                    <span className="verify-step-title">Step 1: Match the Photo.</span>{' '}
                    The person standing in front of you must match the
                    high-resolution photo on the physical ID card.
                  </li>
                  <li>
                    <span className="verify-step-title">Step 2: Inspect the Branding.</span>{' '}
                    Confirm the KCC Parts Distribution logo, employee name, and Employee
                    ID number are clearly printed with no signs of tampering.
                  </li>
                  <li>
                    <span className="verify-step-title">Step 3: Verify the Expiry.</span>{' '}
                    Check the bottom of the card. We do not authorize the use of
                    expired credentials.
                  </li>
                  <li>
                    <span className="verify-step-title">Step 4: Confirm via Phone.</span>{' '}
                    If you are still unsure, please call our Ottawa office
                    immediately at{' '}
                    <a href="tel:+16134074708">+1 613 407 4708</a> and provide
                    the Employee ID number shown on the card.
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={4}>
            <Card className="border-0 shadow-sm verify-assurance h-100">
              <Card.Body>
                <h3 className="h5">Why this matters</h3>
                <p className="mb-3">
                  Our representatives visit shops and warehouses daily. This
                  verification page gives your team a fast, mobile-friendly way
                  to confirm identity before sharing sensitive details or
                  placing orders.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </section>

      <section className="verify-footer">
        <Card className="border-0 verify-banner">
          <Card.Body>
            <h4 className="mb-2">Stay confident with every visit.</h4>
            <p className="mb-0">
              If a representative cannot provide a valid photo ID, please pause
              the interaction and contact KCC Parts Distribution immediately.
            </p>
          </Card.Body>
        </Card>
      </section>
    </>
  );
};

export default VerifyEmployeeScreen;
